import { useParams } from "react-router-dom";
import { HelpLayout, HelpArticleBody } from "@/components/help/HelpLayout";
import { HELP_ARTICLES_BY_SLUG } from "@/lib/help/manifest";
import { SeoHead } from "@/components/SeoHead";
import { MarketingNav } from "@/components/marketing/MarketingNav";
import { MarketingFooter } from "@/components/marketing/MarketingFooter";
import NotFound from "@/pages/NotFound";

const HelpArticlePage = () => {
  const { slug } = useParams<{ slug: string }>();
  const article = slug ? HELP_ARTICLES_BY_SLUG[slug] : undefined;
  if (!article) return <NotFound />;

  return (
    <div className="min-h-screen bg-background text-foreground">
      <SeoHead
        title={`${article.title} — Help`}
        description={article.summary || article.title}
      />
      <MarketingNav />
      <div className="px-4 py-10 sm:px-6">
        <HelpLayout activeSlug={article.slug}>
          <HelpArticleBody article={article} />
        </HelpLayout>
      </div>
      <MarketingFooter />
    </div>
  );
};

export default HelpArticlePage;
